export default function cutStrAtAndAddDots(str, nuOfChar) {
  let returnStr = str;

  if (returnStr != null && returnStr.length >= nuOfChar) {
    returnStr = str.slice(0, nuOfChar) + "...";
  }

  return returnStr;
}
